import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "aos/dist/aos.css";
import AOS from "aos";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InstallPWAButton from "../components/InstallPWAButton";
import {
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Tooltip,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

export default function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/images/landing_background.jpg")})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "repeat-y",
        minHeight: "50vh",
        color: "white",
        fontFamily: "'Baloo Bhaijaan 2', cursive",
        overflow: "auto",
      }}
    >
      <style>
        {`
          @keyframes aiGlow {
            0% {
              box-shadow: 0 0 0 rgba(250, 250, 255, 0.0);
              transform: translateX(-50%) scale(1);
            }
            50% {
              box-shadow: 0 0 18px rgba(250, 250, 255, 0.8);
              transform: translateX(-50%) scale(1.05);
            }
            100% {
              box-shadow: 0 0 0 rgba(250, 250, 255, 0.0);
              transform: translateX(-50%) scale(1);
            }
          }
        `}
      </style>

      {/* Header */}
      <header
        style={{
          width: "100%",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      >
        <img
          src={require("../assets/images/logo_name.PNG")}
          alt="YourStoryWorld Logo"
          style={{
            height: "50px",
            cursor: "pointer",
            flexShrink: 0,
          }}
          onClick={() => navigate("/")}
        />
        <div
          style={{
            display: "inline-flex",
            gap: "15px",
            justifyContent: "flex-end",
            paddingRight: "10px",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          {/* ⭐ New Install App button */}
          <InstallPWAButton />
          <Button
            color="inherit"
            onClick={() => navigate("/login")}
            style={buttonStyle}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#1976D2";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.border = "1px solid white";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.border = "1px solid transparent";
            }}
          >
            Sign In
          </Button>
          <Button
            color="inherit"
            onClick={() => navigate("/help")}
            style={buttonStyle}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#D32F2F";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.border = "1px solid white";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.border = "1px solid transparent";
            }}
          >
            Help
          </Button>
          <Button
            color="inherit"
            onClick={() => navigate("/subscriptions")}
            style={buttonStyle}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#4CAF50";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.border = "1px solid white";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.border = "1px solid transparent";
            }}
          >
            Subscriptions
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
          position: "relative",
          zIndex: 1,
        }}
      >
        
        <img
          src={require("../assets/images/logo.png")}
          alt="YourStoryWorld Logo"
          className="animated-hero-logo"
          style={{
            width: "100%",
            maxWidth: "300px",
            height: "auto",
            marginBottom: "20px",
            animation: "zoomIn 1.5s ease-out",
          }}
        />

       <Typography
          variant="h4"
          style={{
            fontWeight: "bold",
            animation: "fadeIn 2s ease-out",
            marginBottom: "10px",
          }}
        >
          Personalised Stories That Help Children Read, Write and Imagine
        </Typography>
        <Typography
          variant="h6"
          style={{ margin: "20px auto", maxWidth: "700px" }}
        >
          Create, listen to and explore personalised stories that spark imagination, build reading confidence, and support creative writing at home and in school.
        </Typography>

        <div style={{ marginTop: "15px" }}>
          {/* Keep the 2 main CTAs only (as requested) */}
          <Button
            variant="contained"
            color="primary"
            style={{
              ...ctaButton,
              animation: "fadeIn 2.5s ease-out",
              transition: "transform 0.3s, background-color 0.3s",
            }}
            onClick={() => navigate("/auth?plan=free&billing=monthly&reset=1")}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#0D47A1")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#1976D2")
            }
          >
            Try For FREE Now
          </Button>

          <Button
            variant="contained"
            color="secondary"
            style={{
              ...ctaButton,
              animation: "fadeIn 2.5s ease-out",
              transition: "transform 0.3s, background-color 0.3s",
            }}
            onClick={() => navigate("/about")}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#D32F2F")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#F44336")
            }
          >
            Learn More
          </Button>

          <Button
  variant="contained"
  style={{
    margin: "10px",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    fontSize: "18px",        // optional: match CTA size
    fontWeight: "bold",      // ✅ this makes it bold
    textTransform: "uppercase", // optional: match CTA styling
    animation: "fadeIn 2.5s ease-out",
    transition: "transform 0.3s, background-color 0.3s",
  }}
  onClick={() => navigate("/Schools")}
  onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#388E3C")}
  onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#4CAF50")}
>
  For Schools
</Button>

        </div>
        </div>

       
      {/* Trusted by strip (cleaner + less dense) */}
<Container style={{ marginTop: "40px", marginBottom: "20px" }}>
  <Grid container spacing={2} alignItems="center" justifyContent="center">
    <Grid item xs={12} md={6}>
      <Typography
        variant="subtitle1"
        align="center"
        style={{ fontWeight: "bold" }}
      >
        ⭐ Loved by families & early readers, valued by teachers. 
      </Typography>
    </Grid>
    <Grid item xs={12} md={6}>
      <Typography
        variant="body2"
        align="center"
        style={{ fontWeight: "bold" }}
      >
        ⭐ Designed to help children grow in confidence as readers and writers
      </Typography>
    </Grid>

    <Grid item xs={12} md={6}>
      <Typography
        variant="body2"
        align="center"
        style={{ fontWeight: "bold" }}
      >
        ⭐ Built for both storytime at home and meaningful learning in the school classroom.
      </Typography>
    </Grid>

    {/* 📚 Ages line */}
    <Grid item xs={12}>
      <Typography
        variant="subtitle1"
        align="center"
        style={{
          fontWeight: "bold",
          marginTop: "8px",
          marginBottom: "8px",
          color: "#FFEB3B",
        }}
      >
        📚 For all ages from 3–16 · Phonics-aligned · Curriculum-friendly
      </Typography>
    </Grid>
  </Grid>
</Container>


          

      {/* How it works – 3 steps */}
      <Container style={{ marginTop: "40px", marginBottom: "40px" }}>
        <Typography
          variant="h4"
          align="center"
          style={{ fontWeight: "bold", marginBottom: "10px" }}
        >
          How YourStoryWorld Works
        </Typography>
        <Typography
          variant="subtitle1"
          align="center"
          style={{ marginBottom: "30px" }}
        >
          Create personalised stories in three simple steps — designed to make reading more engaging, creative and meaningful.
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4} data-aos="zoom-in">
            <Card style={cardStyle}>
              <CardContent>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  1️⃣ Pick a theme
                </Typography>
                <Typography>
                  Choose from various themes including adventure, action,
                  mystery, comedy and more – or use curriculum-linked topics for
                  class.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4} data-aos="zoom-in">
            <Card style={cardStyle}>
              <CardContent>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  2️⃣ Add your characters
                </Typography>
                <Typography>
                  Add your child’s name, friends, favourite places and interests
                  so every story feels truly theirs.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4} data-aos="zoom-in">
            <Card style={cardStyle}>
              <CardContent>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  3️⃣ Your story comes to life
                </Typography>
                <Typography>
                  Generate a story with audio, comprehension questions and progress features that support reading at home and learning in class.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Adventure Section */}
      <Container style={{ marginTop: "100px", marginBottom: "30px" }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6} data-aos="fade-right">
            <Typography
              variant="h5"
              style={{ fontWeight: "bold", marginBottom: "10px" }}
            >
              Create Any Adventure!
            </Typography>
            <Typography>
              With YourStoryWorld, children can create stories based on their favourite themes, interests and ideas — from football and space to magical worlds and school adventures.
              <br />
              <br />
              By making stories feel personal, YourStoryWorld helps children stay engaged with reading while building confidence, vocabulary and imagination.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
            data-aos="fade-left"
          >
            <img
              src={require("../assets/images/adventure_example.jpg")}
              alt="Adventure Example"
              style={{
                width: "100%",
                maxWidth: "300px",
                height: "auto",
                borderRadius: "10px",
              }}
              loading="lazy"
            />
          </Grid>
        </Grid>
      </Container>

      {/* Imagination Section */}
      <Container style={{ marginTop: "100px", marginBottom: "50px" }}>
        <Grid container spacing={4} alignItems="center">
          <Grid
            item
            xs={12}
            md={6}
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
            data-aos="fade-right"
          >
            <img
              src={require("../assets/images/imagination_example.jpg")}
              alt="Imagination Example"
              style={{
                width: "100%",
                maxWidth: "300px",
                height: "auto",
                borderRadius: "10px",
              }}
              loading="lazy"
            />
          </Grid>
          <Grid item xs={12} md={6} data-aos="fade-left">
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              Unleash Their Imagination!
            </Typography>
            <Typography>
              Children can place themselves and their friends at the centre of stories they genuinely care about. Whether they imagine scoring the winning goal, exploring space, solving a mystery or entering a magical world, YourStoryWorld turns their ideas into stories they want to read.

That sense of ownership helps make reading feel exciting, personal and creative.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      {/* Why Reading Matters Section (shortened slightly) */}
      <Container style={{ marginBottom: "50px" }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6} data-aos="fade-right">
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              Why Reading Matters
            </Typography>
            <Typography>
              Reading helps children develop imagination, vocabulary, knowledge and confidence. Reading for enjoyment is also strongly linked to future learning and academic success.
              <br />
              <br />
              YourStoryWorld encourages children to read because the stories feel relevant, exciting and personal — helping them reconnect with reading in a way that feels natural and enjoyable.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
            data-aos="fade-left"
          >
            <img
              src={require("../assets/images/reading_matters.jpg")}
              alt="Why Reading Matters"
              style={{
                width: "100%",
                maxWidth: "300px",
                height: "auto",
                borderRadius: "10px",
              }}
              loading="lazy"
            />
          </Grid>
        </Grid>
      </Container>

      {/* Schools Section (AI mini-strip merged here) */}
      <Container style={{ marginTop: "100px", marginBottom: "30px" }}>
        <Grid container spacing={4} alignItems="center">
          <Grid
            item
            xs={12}
            md={6}
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
            data-aos="fade-right"
          >
            <img
              src={require("../assets/images/school_section.jpg")}
              alt="School Example"
              style={{
                width: "100%",
                maxWidth: "300px",
                height: "auto",
                borderRadius: "10px",
              }}
              loading="lazy"
            />
          </Grid>

          <Grid item xs={12} md={6} data-aos="fade-left">
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                marginBottom: "6px",
              }}
            >
              Built for Classrooms, Loved by Children
            </Typography>

            {/* 🔹 AI-Ready pill under the heading */}
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "3px 10px",
                borderRadius: "999px",
                backgroundColor: "rgba(37, 99, 235, 0.95)",
                color: "#F9FAFB",
                fontSize: "0.75rem",
                fontWeight: 700,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                marginBottom: "12px",
              }}
            >
              <span style={{ marginRight: 6 }}>AI-Ready ✓</span>
              <span style={{ opacity: 0.9 }}>Supports AI &amp; digital literacy</span>
            </div>

            <Typography>
              YourStoryWorld helps schools make reading more engaging through personalised storytelling. Teachers can use it to support guided reading, classroom discussion, creative writing and early AI literacy — all within a child-friendly platform that children genuinely enjoy using.
            </Typography>

            {/* ✅ merged AI & Digital Literacy content (was the separate mini-strip) */}
            <Card
  style={{
    marginTop: 16,
    backgroundColor: "rgba(0,0,0,0.7)",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.18)",
  }}
>
  <CardContent>
    <Typography
      variant="h6"
      style={{ fontWeight: "bold", marginBottom: "6px", color: "#fff" }}
    >
      AI &amp; Digital Literacy for Schools
    </Typography>

    <Typography
      variant="body2"
      style={{ marginBottom: 12, color: "rgba(255,255,255,0.92)" }}
    >
      YourStoryWorld gives schools a safe and engaging way to introduce AI and digital literacy. Pupils can explore how prompts shape stories, discuss fact and fiction, and begin to understand how AI responds to human input — all through storytelling they enjoy.
    </Typography>

    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => navigate("/ai-for-schools")}
        >
          AI for Schools Overview
        </Button>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Button
          fullWidth
          variant="outlined"
          style={{
            borderColor: "rgba(255,255,255,0.9)",
            color: "#fff",
            backgroundColor: "rgba(255,255,255,0.06)",
          }}
          onClick={() => navigate("/ai-for-schools-page")}
        >
          Teacher Guide &amp; Lessons
        </Button>
      </Grid>
    </Grid>
  </CardContent>
</Card>

          </Grid>
        </Grid>
       
      </Container>

      {/* Empower Every Classroom */}
      <Container style={{ marginBottom: "50px" }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6} data-aos="fade-right">
            <Typography
              variant="h5"
              style={{ fontWeight: "bold", marginBottom: "10px" }}
            >
              Empower Every Classroom
            </Typography>

            <Typography style={{ marginBottom: "10px" }}>
              YourStoryWorld gives teachers practical tools to support literacy, creativity and engagement — while keeping storytelling enjoyable for children.
            </Typography>

            <List dense>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "#4CAF50" }} />
                </ListItemIcon>
                <ListItemText primary="Curriculum-aligned vocabulary" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "#4CAF50" }} />
                </ListItemIcon>
                <ListItemText primary="Weekly teacher-assigned themes" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "#4CAF50" }} />
                </ListItemIcon>
                <ListItemText primary="Comprehension quiz scores" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "#4CAF50" }} />
                </ListItemIcon>
                <ListItemText primary="Student voice recordings" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "#4CAF50" }} />
                </ListItemIcon>
                <ListItemText primary="Engagement analytics and class comparisons" />
              </ListItem>
              {/* NEW: AI literacy bullet */}
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "#4CAF50" }} />
                </ListItemIcon>
                <ListItemText primary="Built-in AI & digital literacy prompts" />
              </ListItem>
            </List>

            <Typography>
              Designed to fit naturally into literacy teaching, story discussion and classroom creativity. Just assign, track, and
              inspire.
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
            data-aos="fade-left"
          >
            <img
              src={require("../assets/images/classroom_pic.jpg")}
              alt="Classroom"
              style={{
                width: "100%",
                maxWidth: "300px",
                height: "auto",
                borderRadius: "10px",
              }}
              loading="lazy"
            />
          </Grid>
        </Grid>
      </Container>

{/* Child-safe by design */}
<Container style={{ marginBottom: "50px" }}>
  <Grid container spacing={4} justifyContent="center">
    <Grid item xs={12} md={10}>
      <Card
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.65)",
          borderRadius: 12,
          padding: 10,
        }}
      >
        <CardContent style={{ paddingBottom: 12 }}>
          <Typography
            variant="subtitle2"
            style={{ fontWeight: "bold", marginBottom: 8, color: "#fff" }}
          >
            🛡 Child-safe by design
          </Typography>

          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                <CheckCircleIcon style={{ color: "#4CAF50", marginTop: 2 }} />
                <Typography variant="body2" style={{ fontWeight: 700, color: "#fff" }}>
                  AI safeguards block inappropriate themes (violence, explicit content, bad language,
                  frightening scenes, unsafe behaviour).
                </Typography>
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                <CheckCircleIcon style={{ color: "#4CAF50", marginTop: 2 }} />
                <Typography variant="body2" style={{ fontWeight: 700, color: "#fff" }}>
                  Positive, age-appropriate storytelling experience across 3–16.
                </Typography>
              </div>
            </Grid>
          </Grid>

          <Typography
            variant="caption"
            style={{
              display: "block",
              marginTop: 10,
              opacity: 0.9,
              color: "#FFEB3B",
            }}
          >
            Learn more in our Child Safety policy.
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Container>

      {/* Testimonials / Social Proof */}
      <Container style={{ marginTop: "60px", marginBottom: "50px" }}>
        <Typography
          variant="h4"
          align="center"
          style={{ fontWeight: "bold", marginBottom: "30px" }}
        >
          Loved by Families &amp; Classrooms
        </Typography>

        <Grid container spacing={4}>
          {/* Testimonial 1 */}
          <Grid item xs={12} md={4} data-aos="fade-up-right">
            <Card
              style={{
                background: "rgba(255, 247, 200, 0.95)", // soft warm yellow
                padding: "20px",
                textAlign: "left",
                borderRadius: "12px",
                boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
                border: "1px solid #f3d98c",
                borderTop: "4px solid #FACC15", // gold accent line
                height: "100%",
                color: "#333",
              }}
            >
              <CardContent>
                <Typography style={{ marginBottom: "10px" }}>
                  “My 6-year-old asks for ‘just one more story’ every night now.
                  The phonics mode has really helped with tricky words.”
                </Typography>
                <Typography
                  variant="subtitle2"
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span role="img" aria-label="star">
                    ⭐
                  </span>
                  Aisha, parent of Year 2 child
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Testimonial 2 */}
          <Grid item xs={12} md={4} data-aos="fade-up">
            <Card
              style={{
                background: "rgba(255, 247, 200, 0.95)",
                padding: "20px",
                textAlign: "left",
                borderRadius: "12px",
                boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
                border: "1px solid #f3d98c",
                borderTop: "4px solid #FACC15",
                height: "100%",
                color: "#333",
              }}
            >
              <CardContent>
                <Typography style={{ marginBottom: "10px" }}>
                  “Perfect for guided reading – I can quickly generate stories
                  at the right level and use the built-in questions for
                  discussion.”
                </Typography>
                <Typography
                  variant="subtitle2"
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span role="img" aria-label="star">
                    ⭐
                  </span>
                  Head Teacher St. Annes Primary School, Birmingham, England
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Testimonial 3 */}
          <Grid item xs={12} md={4} data-aos="fade-up-left">
            <Card
              style={{
                background: "rgba(255, 247, 200, 0.95)",
                padding: "20px",
                textAlign: "left",
                borderRadius: "12px",
                boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
                border: "1px solid #f3d98c",
                borderTop: "4px solid #FACC15",
                height: "100%",
                color: "#333",
              }}
            >
              <CardContent>
                <Typography style={{ marginBottom: "10px" }}>
                  “We love that it reflects different cultures and names – my
                  kids finally see themselves in the stories they read.”
                </Typography>
                <Typography
                  variant="subtitle2"
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span role="img" aria-label="star">
                    ⭐
                  </span>
                  Joanne, mum of two
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Key Features */}
      <Container style={{ marginTop: "80px", marginBottom: "50px" }}>
        <Typography
          variant="h4"
          align="center"
          style={{ fontWeight: "bold", marginBottom: "30px" }}
        >
          Features that Make Reading Fun &amp; Interactive
        </Typography>
        <Grid container spacing={4}>
          {featureList.map((feature, index) => (
            <Grid item xs={12} md={4} key={index} data-aos="zoom-in">
              <Card style={cardStyle}>
                <CardContent>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    {feature.title}
                  </Typography>
                  <Typography>{feature.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

     {/* Subscription Plans - Updated Design with Free Plan highlight */}
<Container style={{ marginBottom: "50px" }}>
  <Typography
    variant="h4"
    align="center"
    style={{ fontWeight: "bold", marginBottom: "30px" }}
  >
    Choose the Perfect Plan for Your Family or School
  </Typography>

  {/* ✅ key: alignItems="stretch" so all cards can become equal height */}
  <Grid container spacing={4} alignItems="stretch">
    {subscriptionPlans.map((plan, index) => {
      const isFree = plan.name === "Free Plan";
      const isSchool = plan.name === "School Plan";

      return (
        <Grid item xs={12} md={3} key={index} style={{ display: "flex" }}>
          {/* ✅ key: height:100% + flex column so button can sit at bottom */}
          <Card
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              background: isFree
                ? "linear-gradient(to right, #4CAF50, #81C784)"
                : "linear-gradient(to right, #A5D6A7, #C8E6C9)",
              color: "white",
              padding: "20px",
              borderRadius: "15px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
              border: isFree ? "3px solid white" : "2px solid white",
              position: "relative",
              transform: isFree ? "scale(1.03)" : "none",
            }}
          >
            {/* ⭐ FREE PLAN RIBBON */}
            {isFree && (
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#FFEB3B",
                  color: "#000",
                  borderRadius: "999px",
                  padding: "4px 12px",
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                Start Free
              </div>
            )}

            {/* 🤖 AI-READY BADGE FOR SCHOOL PLAN */}
            {isSchool && (
              <Tooltip
                title="Includes AI literacy lesson ideas, prompt practice & activities that help pupils tell fiction from fact."
                arrow
              >
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#6D28D9",
                    color: "white",
                    borderRadius: "999px",
                    padding: "5px 14px",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    animation: "aiGlow 1.8s ease-in-out infinite",
                  }}
                >
                  AI-Ready ✓
                </div>
              </Tooltip>
            )}

            {/* ✅ key: flexGrow so content stretches, button can be pushed down */}
            <CardContent
              style={{
                marginTop: isFree || isSchool ? "26px" : 0,
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                padding: 0, // optional: keep internal spacing controlled
              }}
            >
              <Typography
                variant="h6"
                style={{ fontWeight: "bold", textAlign: "center" }}
              >
                {plan.name}
              </Typography>

              <Typography
                style={{
                  textAlign: "center",
                  marginTop: "8px",
                  marginBottom: "8px",
                  minHeight: "60px", // ✅ optional: keeps descriptions visually aligned
                }}
              >
                {plan.description}
              </Typography>

              {/* 🤖 Small AI chip only for the School Plan */}
              {isSchool && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 8,
                  }}
                >
                  <Chip
                    size="small"
                    label="AI literacy & digital skills"
                    style={{
                      backgroundColor: "rgba(15,23,42,0.9)",
                      color: "white",
                      fontWeight: 500,
                    }}
                  />
                </div>
              )}

              {isFree && (
                <Typography
                  variant="body2"
                  style={{
                    textAlign: "center",
                    marginBottom: "8px",
                    fontWeight: "bold",
                  }}
                >
                  Free forever · No credit card required
                </Typography>
              )}

              {/* ✅ key: marginTop:'auto' pushes the button to the bottom */}
              <Button
                variant="contained"
                style={{
                  backgroundColor: "white",
                  color: "#388E3C",
                  fontWeight: "bold",
                  marginTop: "auto",
                  width: "100%",
                }}
                onClick={() => navigate("/subscriptions")}
              >
                View Plans
              </Button>
            </CardContent>
          </Card>
        </Grid>
      );
    })}
  </Grid>
</Container>


      {/* Footer */}
      <footer
        style={{
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#000",
          color: "#fff",
        }}
      >
        {/* Company & rights */}
        <Typography variant="body2">
          © {new Date().getFullYear()} YourStoryWorld Ltd - 
          Company No. 17098564 · All rights reserved.
        </Typography>

        {/* Main nav links */}
        <Typography variant="body2" style={{ marginTop: "8px" }}>
          <a href="/about" style={footerLinkStyle}>
            About Us
          </a>{" "}
          |{" "}
          <a href="/contact" style={footerLinkStyle}>
            Contact
          </a>{" "}
          |{" "}
          <a href="/help" style={footerLinkStyle}>
            Help &amp; FAQs
          </a>
        </Typography>

        {/* Policy links */}
        <Typography variant="body2" style={{ marginTop: 4 }}>
          <a href="/privacy-policy" style={footerLinkStyle}>
            Privacy Policy
          </a>{" "}
          |{" "}
          <a href="/terms" style={footerLinkStyle}>
            Terms of Use
          </a>{" "}
          |{" "}
          <a href="/cookie-policy" style={footerLinkStyle}>
            Cookie Policy
          </a>{" "}
          |{" "}
          <a href="/child-safety" style={footerLinkStyle}>
            Child Safety
          </a>{" "}
          |{" "}
          <a href="/accessibility" style={footerLinkStyle}>
            Accessibility
          </a>{" "}
          |{" "}
          <a href="/data-protection" style={footerLinkStyle}>
            Data Protection &amp; Security
          </a>
        </Typography>

        {/* Disclaimer */}
        <Typography
          variant="caption"
          style={{ marginTop: "10px", display: "block", color: "#ccc" }}
        >
          ⚠️ Disclaimer: The stories generated by YourStoryWorld are created using
          AI and are intended for entertainment and educational purposes only.
          While we strive for accuracy, some content may contain factual or
          narrative inconsistencies.
          <p
            style={{
              fontSize: "0.8rem",
              color: "#e11d48",
              marginTop: "10px",
            }}
          >
            <strong>Child-Safe Content:</strong> YourStoryWorld uses AI safety
            filters to ensure all stories remain age-appropriate. Violent,
            explicit, discriminatory, or harmful content is automatically
            removed or rewritten. Minor variance may occur due to the nature of
            AI generation.
          </p>
        </Typography>
      </footer>
    </div>
  );
}

/* 🔹 Style Constants */
const buttonStyle = {
  fontSize: "16px",
  fontWeight: "bold",
  textTransform: "uppercase",
  color: "white",
  border: "1px solid transparent",
  transition: "all 0.3s ease",
};

const ctaButton = {
  margin: "10px",
  padding: "10px 20px",
  fontSize: "18px",
  fontWeight: "bold",
  textTransform: "uppercase",
};

const cardStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  padding: "20px",
  textAlign: "center",
  borderRadius: "10px",
};

const footerLinkStyle = {
  color: "white",
  textDecoration: "none",
};

/* 🔹 Feature List */
const featureList = [
  {
    title: "Personalised Stories",
    description:
      "Create unique stories tailored to your child's imagination and interests.",
  },
  {
    title: "Age & Region-Smart Language & Vocabulary Builder",
    description: "Tailored vocabulary for different age groups and location as well as personalised word bank for each story.",
  },
  {
    title: "Family & School Dashboards",
    description:
      "Track reading habits, progress, and achievements for all children.",
  },
  {
    title: "Phonics-Aligned Reading",
    description:
      "Supports early learning with structured vocabulary for beginners.",
  },
  {
    title: "Immersive Audio Playback",
    description:
      "Listen to stories come to life with engaging voiceovers and word narration.",
  },
  {
    title: "Comprehension Practice/Quizzes",
    description:
      "Boost understanding with auto-generated questions tied to each story.",
  },
  {
    title: "Voice Recording & Review",
    description:
      "Students record readings and submit them to teachers for feedback.",
  },
  {
    title: "Teacher-Assigned Themes",
    description: "Educators can assign weekly themes to guide student creativity.",
  },
  {
    title: "Advanced Analytics",
    description:
      "Track story engagement, comprehension accuracy, and voice submissions.",
  },
];

/* 🔹 Subscription Plans */
const subscriptionPlans = [
  {
    name: "Free Plan",
    description:
      "Access core features with 5 stories per month completely free.",
  },
  {
    name: "Personal Plan",
    description:
      "All the premium features with smart dashboard analytics for parents.  Access to 50 stories per month, comprehension quizzes, vocabulary builder & phonics support for younger children",
  },
  {
    name: "Family Plan",
    description:
      "Multiple profiles for up to 4 family members with a shared dashboard and all features available in Personal plan",
  },
  {
    name: "School Plan",
    description:
      "Includes classroom & story theme management, analytics tracking, voice submissions, and tools to support AI & digital literacy in line with school needs.",
  },
];
